type BootstrapSteps<T> = {
  loadTenant: () => Promise<unknown>;
  loadTranslations: () => Promise<unknown>;
  loadApp: () => Promise<T>;
};

/**
 * Startup order for index.tsx.
 *
 * The tenant and the translations are independent requests, so
 * they run in parallel. The app bundle is only imported once
 * both are done: importing it evaluates the module graph, and
 * menus, exporter fields and other definitions translate their
 * labels at module scope. Evaluating them before the strings
 * are in polyglot freezes the raw keys into the UI.
 *
 * The bundle download itself does not wait: the build injects
 * a `modulepreload` link for it (see build-plugins/preloadChunks).
 */
export async function bootstrap<T>({
  loadTenant,
  loadTranslations,
  loadApp,
}: BootstrapSteps<T>): Promise<T> {
  await Promise.all([loadTenant(), loadTranslations()]);

  return loadApp();
}
